import { Injectable } from '@angular/core';
import { LocalStorageSvc } from './localStorage.service';
import { UniversalService } from './universal.service';

@Injectable({
  providedIn: 'root'
})
export class InappWebviewService {
  isIOSDevice:boolean;
  
  constructor(public universalService:UniversalService,public localStorageService:LocalStorageSvc) { 
    this.universalService.checkDeviceType();
  }

  checkiOSdevice() {
    return [
       'iPad Simulator',
       'iPhone Simulator',
       'iPod Simulator',
       'iPad',
       'iPhone',
       'iPod'
     ].includes(navigator.platform)
     || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
 }
}
